import { isProdEnvironment } from '@codes/web-core';

import { MarketplaceProject } from '../types';

// NOTE: Do not delete below
// export const DUMMY_MOCK_PROJECTS: MarketplaceProject[] = [
//     {
//         id: '1',
//         title: 'Blog Generator',
//         description: 'AI-powered blog post generator with SEO optimization and multiple templates',
//         author: 'Lemon Cloud Team',
//         category: 'tool',
//         tags: ['AI', 'Content', 'SEO'],
//         githubUrl: 'https://github.com/lemoncloud-io/blog-generator',
//         demoUrl: 'https://demo.codes.lemoncloud.io/blog-generator',
//         previewImage: 'https://korean-soft-tts.s3.ap-northeast-2.amazonaws.com/preview.png',
//         createdAt: '2025-01-15T10:00:00Z',
//         updatedAt: '2025-01-20T14:30:00Z',
//         version: '1.2.0',
//         downloads: 245,
//         likes: 89,
//     },
//     {
//         id: '2',
//         title: 'Background Remover',
//         description: 'Remove backgrounds from images using AI with high precision and batch processing',
//         author: 'Lemon Cloud Team',
//         category: 'tool',
//         tags: ['AI', 'Image', 'Processing'],
//         githubUrl: 'https://github.com/lemoncloud-io/bg-remover',
//         demoUrl: 'https://demo.codes.lemoncloud.io/bg-remover',
//         previewImage: '',
//         createdAt: '2025-01-10T09:00:00Z',
//         updatedAt: '2025-01-18T16:00:00Z',
//         version: '2.0.1',
//         downloads: 512,
//         likes: 156,
//     },
//     {
//         id: '3',
//         title: 'Invoice Generator',
//         description: 'Professional invoice generator with customizable templates and PDF export',
//         author: 'Community',
//         category: 'template',
//         tags: ['Business', 'Finance', 'PDF'],
//         githubUrl: 'https://github.com/example/invoice-gen',
//         demoUrl: 'https://demo.codes.lemoncloud.io/invoice-gen',
//         previewImage: '',
//         createdAt: '2025-01-05T11:00:00Z',
//         updatedAt: '2025-01-15T10:00:00Z',
//         version: '1.0.5',
//         downloads: 324,
//         likes: 112,
//     },
//     {
//         id: '4',
//         title: 'Task Manager Widget',
//         description: 'Lightweight task management widget with drag-and-drop and priority levels',
//         author: 'Community',
//         category: 'widget',
//         tags: ['Productivity', 'Tasks', 'UI'],
//         githubUrl: 'https://github.com/example/task-widget',
//         previewImage: '',
//         createdAt: '2025-01-08T14:00:00Z',
//         updatedAt: '2025-01-19T12:00:00Z',
//         version: '1.1.2',
//         downloads: 178,
//         likes: 67,
//     },
//     {
//         id: '5',
//         title: 'Email Automation',
//         description: 'Automate email campaigns with templates, scheduling, and analytics tracking',
//         author: 'Lemon Cloud Team',
//         category: 'automation',
//         tags: ['Email', 'Marketing', 'Automation'],
//         githubUrl: 'https://github.com/lemoncloud-io/email-automation',
//         demoUrl: 'https://demo.codes.lemoncloud.io/email-automation',
//         previewImage: '',
//         createdAt: '2025-01-12T08:00:00Z',
//         updatedAt: '2025-01-22T15:00:00Z',
//         version: '1.3.0',
//         downloads: 421,
//         likes: 143,
//     },
//     {
//         id: '6',
//         title: 'Landing Page Template',
//         description: 'Modern landing page template with responsive design and conversion optimization',
//         author: 'Community',
//         category: 'template',
//         tags: ['Design', 'Marketing', 'Responsive'],
//         githubUrl: 'https://github.com/example/landing-template',
//         demoUrl: 'https://demo.codes.lemoncloud.io/landing-template',
//         previewImage: '',
//         createdAt: '2025-01-03T13:00:00Z',
//         updatedAt: '2025-01-17T11:00:00Z',
//         version: '2.1.0',
//         downloads: 689,
//         likes: 234,
//     },
//     {
//         id: '7',
//         title: 'QR Code Generator',
//         description: 'Generate custom QR codes with logo embedding and multiple export formats',
//         author: 'Community',
//         category: 'tool',
//         tags: ['QR Code', 'Utility', 'Export'],
//         githubUrl: 'https://github.com/example/qr-generator',
//         demoUrl: 'https://demo.codes.lemoncloud.io/qr-generator',
//         previewImage: '',
//         createdAt: '2025-01-07T10:00:00Z',
//         updatedAt: '2025-01-21T09:00:00Z',
//         version: '1.0.3',
//         downloads: 267,
//         likes: 91,
//     },
//     {
//         id: '8',
//         title: 'Data Sync Automation',
//         description: 'Automatically sync data between different platforms with scheduled jobs',
//         author: 'Lemon Cloud Team',
//         category: 'automation',
//         tags: ['Integration', 'Sync', 'API'],
//         githubUrl: 'https://github.com/lemoncloud-io/data-sync',
//         previewImage: '',
//         createdAt: '2025-01-09T15:00:00Z',
//         updatedAt: '2025-01-16T13:00:00Z',
//         version: '1.1.0',
//         downloads: 156,
//         likes: 54,
//     },
// ];

// Development environment mock projects with dev URLs
export const MOCK_PROJECTS_DEV: MarketplaceProject[] = [
    {
        id: '1',
        title: 'Korean Soft TTS',
        description: 'Natural Korean AI Voice Generator with various options',
        author: 'LemonCloud Team',
        category: 'app',
        tags: ['AI', 'TTS', 'DEV'],
        githubUrl: 'https://github.com/lemoncloud-io/codes-monorepo-template/tree/app/korean-soft-tts',
        demoUrl: 'http://codes-korean-soft-tts-front.s3-website.ap-northeast-2.amazonaws.com/',
        previewImage: 'https://korean-soft-tts.s3.ap-northeast-2.amazonaws.com/preview.png',
        createdAt: '2025-11-20T10:00:00Z',
        updatedAt: '2025-11-28T14:30:00Z',
        version: '2.0.0',
        downloads: 0,
        likes: 0,
    },
    {
        id: '2',
        title: '오늘의 한 줄',
        description: 'AI가 전하는 당신만을 위한 맞춤형 지혜와 영감',
        author: 'LemonCloud Team',
        category: 'app',
        tags: ['AI', 'DEV'],
        githubUrl: 'https://github.com/lemoncloud-io/codes-monorepo-template',
        demoUrl: 'http://eureka-09f66e40-dee5-437e-8ba4-abbc2a7458f0.s3-website.ap-northeast-2.amazonaws.com/',
        previewImage: 'https://korean-soft-tts.s3.ap-northeast-2.amazonaws.com/insight_preview.png',
        createdAt: '2025-12-01T10:00:00Z',
        updatedAt: '2025-12-01T15:30:00Z',
        version: '1.0.0',
        downloads: 0,
        likes: 0,
    },
];

// Production environment mock projects with prod URLs
export const MOCK_PROJECTS_PROD: MarketplaceProject[] = [
    {
        id: '1',
        title: 'Korean Soft TTS',
        description: 'Natural Korean AI Voice Generator with various options',
        author: 'LemonCloud Team',
        category: 'app',
        tags: ['AI', 'TTS', 'PROD'],
        githubUrl: 'https://github.com/lemoncloud-io/codes-monorepo-template/tree/app/korean-soft-tts',
        demoUrl: 'http://korean-soft-tts.s3-website.ap-northeast-2.amazonaws.com/',
        previewImage: 'https://korean-soft-tts.s3.ap-northeast-2.amazonaws.com/preview.png',
        createdAt: '2025-11-20T10:00:00Z',
        updatedAt: '2025-11-28T14:30:00Z',
        version: '2.0.0',
        downloads: 0,
        likes: 0,
    },
    {
        id: '2',
        title: '오늘의 한 줄',
        description: 'AI가 전하는 당신만을 위한 맞춤형 지혜와 영감',
        author: 'LemonCloud Team',
        category: 'app',
        tags: ['AI', 'PROD'],
        githubUrl: 'https://github.com/lemoncloud-io/codes-monorepo-template',
        demoUrl: 'http://eureka-09f66e40-dee5-437e-8ba4-abbc2a7458f0.s3-website.ap-northeast-2.amazonaws.com/',
        previewImage: 'https://korean-soft-tts.s3.ap-northeast-2.amazonaws.com/insight_preview.png',
        createdAt: '2025-12-01T10:00:00Z',
        updatedAt: '2025-12-01T15:30:00Z',
        version: '1.0.0',
        downloads: 0,
        likes: 0,
    },
];

/**
 * Get mock projects based on current environment
 * @returns MOCK_PROJECTS_PROD if in production, MOCK_PROJECTS_DEV otherwise
 */
export const getMockProjects = (): MarketplaceProject[] => {
    return isProdEnvironment() ? MOCK_PROJECTS_PROD : MOCK_PROJECTS_DEV;
};
